(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductLotDialogController', ProductLotDialogController);

    ProductLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductLot', 'Product'];

    function ProductLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductLot, Product) {
        var vm = this;
        vm.productLot = entity;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productLotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productLot.id !== null) {
                ProductLot.update(vm.productLot, onSaveSuccess, onSaveError);
            } else {
                ProductLot.save(vm.productLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.registrationDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
